import React from 'react';
import { CTAButton } from './CTAButton';
import { heroBadges, heroTrust, stats, MOCKUP_IMAGE } from '../data/content';
export function Hero() {
  return <header className="w-full bg-ink-900 px-4 pb-8 pt-4 sm:px-6 sm:pb-12 sm:pt-8" data-id="element-87" data-mp="ehtkhzt5b7pe">
      <div className="mx-auto max-w-3xl text-center" data-id="element-88" data-mp="9lbkfd8rfxje">
        <h1 className="text-[1.55rem] font-extrabold uppercase leading-[1.08] tracking-tight text-gold-500 sm:text-4xl lg:text-5xl" data-id="element-89" data-mp="4m8mecr76rkx">
          Sistema Stock Cero™
        </h1>
        <p className="mt-2 text-[0.95rem] font-bold leading-tight text-white sm:text-xl lg:text-2xl" data-id="element-90" data-mp="xae8b2tzmmmc">
          Vacía tus estanterías. Lográ que te vuelvan a comprar.
          <span className="text-gold-400" data-id="element-91" data-mp="s9ggdyj6ee7n"> Sin depender de la suerte.</span>
        </p>

        <div className="mt-3 flex justify-center sm:mt-5" data-id="element-92" data-mp="nbop96qcuw4i">
          <img src={MOCKUP_IMAGE} alt="Sistema Stock Cero: 2 tomos y 10 bonos para comerciantes argentinos" className="h-auto max-h-[30vh] w-auto max-w-full object-contain sm:max-h-[320px]" data-id="element-93" data-mp="3d21rlvg2wgmo" />
        </div>

        <p className="mx-auto mt-3 max-w-xl text-[13px] font-semibold leading-snug text-white sm:mt-5 sm:text-base" data-id="element-94" data-mp="3j9ah3d0igq55">
          El sistema N°1 para comerciantes argentinos. Más stock rotado. Más
          ventas cerradas. Más clientes nuevos.
          <span className="text-gold-400" data-id="element-95" data-mp="3e963buqzm9im"> Copiás. Ejecutás. Vendés.</span>
        </p>

        <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-medium text-neutral-400 sm:text-sm" data-id="element-96" data-mp="30i19586e29fo">
          {heroBadges.map(badge => <li key={badge} data-id="element-97" data-mp="35aklk1tcayiw">{badge}</li>)}
        </ul>

        <div className="mx-auto mt-3 max-w-md sm:mt-5" data-id="element-98" data-mp="2ql68ojqk1yyr">
          <CTAButton href="#ofertas" data-id="element-99" data-mp="2viol4k3s6wbi">
            📦 Quiero mi Sistema Stock Cero™ →
          </CTAButton>
        </div>

        <ul className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-medium text-neutral-500 sm:text-sm" data-id="element-100" data-mp="2hix224yeqpqn">
          {heroTrust.map(item => <li key={item} data-id="element-101" data-mp="s2jmpvqkdyiz">{item}</li>)}
        </ul>

        <dl className="mx-auto mt-6 grid max-w-2xl grid-cols-2 gap-2 sm:mt-9 sm:grid-cols-4 sm:gap-3" data-id="element-102" data-mp="s44j7qwfvrjh">
          {stats.map(stat => <div key={stat.label} className="rounded-lg border border-white/10 bg-ink-800 px-2 py-3" data-id="element-103" data-mp="ibp18tl572yl">
              <dt className="sr-only" data-id="element-104" data-mp="deq4e3a3ghwp">{stat.label}</dt>
              <dd data-id="element-105" data-mp="1b1fe6zb1fyt4">
                <span className="block text-xl font-extrabold text-gold-500 sm:text-2xl" data-id="element-106" data-mp="1azulzgc74ryf">
                  {stat.value}
                </span>
                <span className="mt-0.5 block text-[10px] leading-tight text-neutral-400 sm:text-xs" data-id="element-107" data-mp="15zztx9gopwbs">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}